import { useCallback, useRef } from 'react';

export function useRateLimit(cooldownMs: number = 5000) {
  const lastRef = useRef<number>(0);

  const canAct = useCallback((): boolean => {
    const now = Date.now();
    if (now - lastRef.current < cooldownMs) return false;
    lastRef.current = now;
    return true;
  }, [cooldownMs]);

  const remainingMs = useCallback((): number => {
    const elapsed = Date.now() - lastRef.current;
    return Math.max(0, cooldownMs - elapsed);
  }, [cooldownMs]);

  return { canAct, remainingMs };
}
